module.exports = __webpack_public_path__ + "img/checkup_SanKart-450x300.3803ec13.jpg";